// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_t7-0";
export var checkoutRateBadgeLink = "_t7-1";